/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useEffect, useRef, useState } from "react";
import Container from "../../../Container/Container";
import AndreasQuaukeImage from "../../../../assets/img/employees/Andreas_Quauke.png";
import AngelaFeilImage from "../../../../assets/img/employees/Angela_Feil.png";
import AnnaBeitenImage from "../../../../assets/img/employees/Anna_Beiten.png";
import ChristopherKrauseImage from "../../../../assets/img/employees/Christopher_Krause.png";
import DarioBorningImage from "../../../../assets/img/employees/Dario_Borning.png";
import ElenorGrubImage from "../../../../assets/img/employees/Elenor_Grub.png";
import FrankRiedelImage from "../../../../assets/img/employees/Frank_Riedel.png";
import FrederikSchierImage from "../../../../assets/img/employees/Frederik_Schier.png";
import HaraldHoevelerImage from "../../../../assets/img/employees/Harald_Hoeveler.png";
import KatharinaPitzenImage from "../../../../assets/img/employees/Katharina_Pitzen.png";
import KristinaBeyerImage from "../../../../assets/img/employees/Kristina_Beyer.png";
import LaraVonKolontajImage from "../../../../assets/img/employees/Lara_von_Kolontaj.png";
import MajaVonKutzschenbachImage from "../../../../assets/img/employees/Maja_von_Kutzschenbach.png";
import MelanieTreudeImage from "../../../../assets/img/employees/Melanie_Treude.png";
import MeralCitakImage from "../../../../assets/img/employees/Meral_Citak.png";
import MichaelBickImage from "../../../../assets/img/employees/Michael_Bick.png";
import SarahLongerichImage from "../../../../assets/img/employees/Sarah_Longerich.png";
import SebastianPleissImage from "../../../../assets/img/employees/Sebastian_Pleiss.png";
import SonjaHartmannImage from "../../../../assets/img/employees/Sonja_Hartmann.png";
import AttorneysImage from "../../../../assets/img/jobs/Anwaelte.svg";
import Typography from "@mui/material/Typography";
import PictureTeaserCard from "../../../Cards/PictureTeaserCard/PictureTeaserCard";
import teamSectionStyle from "./teamSectionStyle";
import { Box, Button, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";

type TeamSectionProps = {
  headline?: string;
  subHeadline?: string;
  isSubsection?: boolean;
  showHeadings?: boolean;
  sectionPadding?: boolean;
};

type EmployeeItem = {
  title: string;
  subTitle?: string;
  image: string;
};

const TeamSection = ({ headline = "", subHeadline, isSubsection = false, showHeadings = true, sectionPadding = true }: TeamSectionProps) => {
  const [showAllEmployees, setShowAllEmployees] = useState(false);
  const toggleButtonRef = useRef<HTMLDivElement | null>(null);

  const employees: EmployeeItem[] = [
    {
      title: "Andreas Quauke",
      image: AndreasQuaukeImage,
    },
    {
      title: "Angela Feil",
      image: AngelaFeilImage,
    },
    {
      title: "Anna Beiten",
      image: AnnaBeitenImage,
    },
    {
      title: "Christopher Krause",
      image: ChristopherKrauseImage,
    },
    {
      title: "Dario Borning",
      image: DarioBorningImage,
    },
    {
      title: "Elenor Grub",
      image: ElenorGrubImage,
    },
    {
      title: "Frank Riedel",
      image: FrankRiedelImage,
    },
    {
      title: "Frederik Schier",
      image: FrederikSchierImage,
    },
    {
      title: "Harald Höveler",
      image: HaraldHoevelerImage,
    },
    {
      title: "Katharina Pitzen",
      image: KatharinaPitzenImage,
    },
    {
      title: "Kristina Beyer",
      image: KristinaBeyerImage,
    },
    {
      title: "Lara von Kolontaj",
      image: LaraVonKolontajImage,
    },
    {
      title: "Maja von Kutzschenbach",
      image: MajaVonKutzschenbachImage,
    },
    {
      title: "Melanie Treude",
      image: MelanieTreudeImage,
    },
    {
      title: "Meral Citak",
      image: MeralCitakImage,
    },
    {
      title: "Michael Bick",
      image: MichaelBickImage,
    },
    {
      title: "Sarah Longerich",
      image: SarahLongerichImage,
    },
    {
      title: "Sebastian Pleiß",
      image: SebastianPleissImage,
    },
    {
      title: "Sonja Hartmann",
      image: SonjaHartmannImage,
    },
    {
      title: "… und viele Weitere",
      subTitle: "sind jederzeit für Sie da!",
      image: AttorneysImage,
    },
  ];

  useEffect(() => {
    if (!showAllEmployees && toggleButtonRef.current) {
      toggleButtonRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [showAllEmployees]);

  return (
    <Container sectionPadding={sectionPadding}>
      {showHeadings && (
        <>
          {!isSubsection && <Box sx={teamSectionStyle.scrollToAnchor} id="partneranwaelte" />}
          <Typography variant={"h2"} sx={teamSectionStyle.headline}>
            {!isSubsection && headline}
          </Typography>
          <Typography variant={"h3"} sx={teamSectionStyle.headline}>
            {isSubsection ? headline : subHeadline}
          </Typography>
        </>
      )}
      <Grid container spacing={2} sx={{
        justifyContent: "center"
      }}>
        {employees.map((item: EmployeeItem, index: number) => (
          <Grid
            key={item.title}
            sx={{ display: { xs: index < 4 || showAllEmployees ? "block" : "none", md: "block" } }}
            size={{
              xl: 3,
              lg: 4,
              md: 6,
              xs: 12
            }}>
            <PictureTeaserCard image={item.image} title={item.title} subTitle={item.subTitle} />
          </Grid>
        ))}
      </Grid>
      <Stack
        ref={toggleButtonRef}
        direction="row"
        sx={{
          justifyContent: "center",
          display: { xs: "flex", md: "none" },
          mt: "1rem",
          scrollMarginTop: "15rem"
        }}>
        <Button onClick={() => setShowAllEmployees((prev) => !prev)}>{showAllEmployees ? "WENIGER ANZEIGEN" : "ALLE ANZEIGEN"}</Button>
      </Stack>
    </Container>
  );
};

export default TeamSection;
